import Alderwood1 from "../Summarecon Bogor/The Alderwood.webp"
import Alderwood2 from "../Summarecon Bogor/The Alderwood.webp"

const Alderwoodimages =[
    Alderwood1,Alderwood2
]

export default Alderwoodimages;